import { ActionTreeWithRootState } from '~/store/types'
import {
  CLEAR_NOTIFICATION_CENTER_DATA,
  SET_USER_DATA,
  SET_USER_EXTRA_DATA,
  SET_USER_NOTIFICATION_CENTER_DATA,
  SET_USER_NOTIFICATION_CENTER_LOADING_STATE
} from './mutation-types'
import { USER_NS, UserState } from './state'
import { SET_ADMIN_EXTRA_DATA } from '~/store/modules/shared/admin/user/mutation-types'
import { ADMINUSER_NS } from '~/store/modules/shared/admin/user/state'
import { UserType } from '~/models/user/types'
import NotificationCenterService from '~/services/notification/NotificationCenterService'
import { AxiosError } from 'axios'
import { NotificationTypeEnum } from '~/models/notification-center/types'
import AuthUserService from '~/services/user/AuthUserService'
import UserExtrasService from '~/services/user/UserExtrasService'
import { HttpStatus } from '~/constants/http'

export default {
  async loadUser({ dispatch }) {
    try {
      await Promise.all([
        dispatch('loadAuthUserData'),
        dispatch('loadUserExtras')
      ])
    } catch (error) {
      const { response } = error
      if (response) {
        return this.$error({ statusCode: error.response.status })
      }

      this.$logger.captureError(error as Error)
      return this.$error({ statusCode: HttpStatus.INTERNAL_SERVER_ERROR })
    }
  },
  async loadAuthUserData({ commit }) {
    const authUserService = this.$dep(AuthUserService)

    const userData = await authUserService.getUser()

    commit(SET_USER_DATA, userData)
    this.$logger.setUser(userData)
  },
  async loadUserExtras({ state, commit }) {
    const userExtrasService = this.$dep(UserExtrasService)

    const {
      userExtras,
      adminExtrasData
    } = await userExtrasService.getUserExtras()
    commit(SET_USER_EXTRA_DATA, userExtras)

    if (
      adminExtrasData &&
      (state.type === UserType.ADMIN || adminExtrasData.adminExtras.suas)
    ) {
      commit(`${ADMINUSER_NS}/${SET_ADMIN_EXTRA_DATA}`, adminExtrasData, {
        root: true
      })
    }
  },
  async reloadUserExtras({ dispatch, getters }) {
    if (getters.isAdmin) {
      return
    }

    await dispatch('loadUserExtras')
  },
  async fetchNotificationCenterData(
    { dispatch, commit },
    { page, types }: { page: number; types: Array<NotificationTypeEnum> }
  ) {
    const notificationCenterService = this.$dep(NotificationCenterService)
    commit(SET_USER_NOTIFICATION_CENTER_LOADING_STATE, true)
    if ((page === 1 || !page) && !types) {
      commit(CLEAR_NOTIFICATION_CENTER_DATA)
    }
    try {
      const {
        notifications,
        notificationTypes
      } = await notificationCenterService.fetchNotification(page, types)
      commit(SET_USER_NOTIFICATION_CENTER_DATA, {
        notifications,
        notificationTypes
      })
      if (process.server) {
        await dispatch(`${USER_NS}/loadUser`, {}, { root: true })
      } else {
        dispatch(`${USER_NS}/loadUser`, {}, { root: true })
      }
    } catch (e) {
      notificationCenterService.handleError(e as AxiosError)
    } finally {
      commit(SET_USER_NOTIFICATION_CENTER_LOADING_STATE, false)
    }
  }
} as ActionTreeWithRootState<UserState>
